<script setup>
import { computed } from "vue";

import FancySlider from "@components/redesign/FancySlider/FancySlider.vue";
import VideoCard from "@/components/redesign/VideoCard/VideoCard.vue";
import CircleButton from "@/components/redesign/CircleButton/CircleButton.vue";

import list from "./list";
import womenList from "./womenList";

const props = defineProps({
  theme: { type: String, default: "" }, // blue | pink
});

const trustedList = computed(() => {
  return props.theme === "pink" ? womenList : list;
});
</script>

<template>
  <div class="trusted-list" :class="theme">
    <div class="header">
      <h2 class="r-h4-to-h2">
        Access the same A-list care, trusted by the best
      </h2>
    </div>

    <div class="slider-wrapper hidden-mobile">
      <FancySlider mode="slide" focus-slides>
        <VideoCard
          v-for="person in trustedList"
          :key="person.title"
          :image="person.image"
          :alt="person.alt"
          :title="person.title"
          :description="person.description"
          :video="person.video"
          :light="theme === 'pink'"
        />
      </FancySlider>

      <router-link class="circle-button" to="/company/testimonials">
        <CircleButton
          label="View All"
          :pink="theme === 'pink'"
          url="/company/testimonials"
        />
      </router-link>
    </div>

    <div class="mobile-slider-wrapper hidden-tablet hidden-desktop">
      <div>
        <VideoCard
          :image="trustedList[0].image"
          :alt="trustedList[0].alt"
          :title="trustedList[0].title"
          :description="trustedList[0].description"
          :video="trustedList[0].video"
          :light="theme === 'pink'"
        />
      </div>
      <div class="mobile-slider">
        <VideoCard
          v-for="person in trustedList.slice(1)"
          :key="person.title"
          :image="person.image"
          :alt="person.alt"
          :title="person.title"
          :description="person.description"
          :video="person.video"
          :light="theme === 'pink'"
          tiny
        />
      </div>
    </div>
  </div>
</template>

<style scoped src="./style.scss" lang="scss" />
